
export class AutomationsText {
    [key: string]: string;
}

export class AutomationsAlias {
    Inputs: InputsAlias[];
    Outputs: OutputsAlias[];
    Selectors: SelectorsAlias[];
}

export class InputsAlias {
    Id: number;
    Description: string;
    DefaultDescription?: string;
    StateOn: string;
    DefaultStateOn?: string;
    StateOff: string;
    DefaultStateOff?: string;
}

export class OutputsAlias {
    Id: number;
    Description: string;
    DefaultDescription?: string;
    StateOn: string;
    DefaultStateOn?: string;
    StateOff: string;
    DefaultStateOff?: string;
}

export class SelectorsAlias {
    Id: number;
    Description: string;
    DefaultDescription?: string;
} 